import { ArrowDownUp } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";

interface ColumnsProps {
  columnName: (data: any) => void;
  pdfRenderInvoice: (data: any) => void;
  handlersettlement: (data: any) => void;
}

const InvoiceClumn = ({
  columnName,
  handlersettlement,
  pdfRenderInvoice,
}: ColumnsProps) => {
  const InvoiceClumn = useMemo(
    () => [
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("farmer_name")}
          >
            <span>نام کشاورز</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "farmer_name",
        enableColumnFilter: false,
      },

      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("remaining_receivable_payable_balance")}
          >
            <span> مانده طلب / بدهی</span>
            <span className="text-blue-600 text-[10px]">(تومان)</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "remaining_receivable_payable_balance",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          const absValue = value ? Math.abs(value) : 0;
          const formattedValue = absValue.toLocaleString("fa-IR", {
            maximumFractionDigits: 0,
          });
          return (
            <span
              className={
                value >= 0
                  ? "text-green-600 center font-bold text-lg"
                  : "text-red-600 font-bold text-lg center"
              }
            >
              {formattedValue}
              <span className="px-1 text-lg">
                {value > 0 ? "+" : value < 0 ? "-" : ""}
              </span>
            </span>
          );
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("total_weight")}
          >
            <span>وزن کل بارها</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "total_weight",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },

      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("pure_payable")}
          >
            <span>مبلغ کل بارها </span>
            <span className="text-blue-600 text-[10px]">(تومان)</span>

            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "pure_payable",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("newest_date")}
          >
            <span> تاریخ اخرین بار تحویلی </span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "newest_date",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("total_farmers_price")}
          >
            <span> جمع پرداخت‌ها </span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "total_farmers_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },

      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("total_seed_cost")}
          >
            <span> بدهی بذر </span>
            <span className="text-blue-600 text-[10px]">(تومان)</span>

            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "total_seed_cost",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("total_pesticide_cost")}
          >
            <span>بدهی سم </span>
            <span className="text-blue-600 text-[10px]">(تومان)</span>

            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "total_pesticide_cost",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("total_guarantee_price")}
          >
            <span> بدهی ضمانت </span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "total_guarantee_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },

      {
        header: "۱ درصد کارمزد پیمانکار",
        accessorKey: "one_percent_deduction",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3 ml-2">
            {cell.row.original.payed ? (
              <span className="flex items-center cursor-not-allowed px-2 py-1 rounded-lg bg-gray-600 text-white">
                تسویه شده
              </span>
            ) : (
              <Link
                to="#!"
                className="flex items-center justify-center transition-all duration-300 ease-in-out"
                onClick={() => {
                  const data = cell.row.original;
                  handlersettlement(data);
                }}
              >
                <span className="flex items-center px-2 py-1 rounded-lg bg-gradient-to-r hover:scale-105 from-green-500 to-emerald-600 text-white shadow-lg hover:shadow-emerald-500/30 hover:from-green-600 hover:to-emerald-700 transition-all duration-300 group">
                  <span className="font-medium">تسویه</span>
                </span>
              </Link>
            )}
          </div>
        ),
      },
      {
        header: "صورتحساب",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3 ml-2">
            <Link
              to="#!"
              className="flex items-center justify-center transition-all duration-300 ease-in-out"
              onClick={() => {
                // کل ردیف ارسال می‌شود تا نام پیمانکار همان کشاورز در PDF بیاید
                pdfRenderInvoice(cell.row.original);
              }}
            >
              <span className="flex items-center px-2 py-1 rounded-lg bg-gradient-to-r hover:scale-105 from-blue-500 to-gray-600 text-white shadow-lg hover:shadow-emerald-500/30 hover:from-green-600 hover:to-emerald-700 transition-all duration-300 group">
                <span className="font-medium"> صورتحساب نهایی</span>
              </span>
            </Link>
          </div>
        ),
      },
      {
        header: "شناسه کشاورز",
        accessorKey: "farmer_id",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value
            ? value.toLocaleString("fa-IR", { maximumFractionDigits: 0 })
            : "0";
        },
      },
    ],
    []
  );

  return InvoiceClumn;
};

export default InvoiceClumn;
